/** @jsxImportSource @emotion/react */
import { jsx } from '@emotion/react';
import React from 'react';

import { TypographyStyles } from 'src/common/ui/base/Typography';

type TypographyKeys = keyof typeof TypographyStyles;
type PickedType<T, K extends T> = K;

type Variants = PickedType<
  TypographyKeys,
  'headline1' | 'headline2' | 'subtitle1' | 'subtitle2' | 'overline'
>;

/**
 * Title component for typographic headers.
 *
 * @param component - The HTML component level of the header.
 * @param variant - The style of the header.
 */
export const Header = ({
  children,
  className,
  component = 'h1',
  variant = 'headline1',
}: React.PropsWithChildren<{
  className?: string;
  component?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  variant?: Variants;
}>) =>
  jsx(
    component,
    { css: TypographyStyles[variant], className, 'data-testid': 'nds-component-header' },
    children,
  );
